import React, { useState, useEffect } from "react";
import { Button, Table } from "react-bootstrap";
import { BiMessageSquareDetail } from "react-icons/bi";
import config from "../../config/config";
import Loader from "../loader/Loader";
import { getAuthToken } from "../../utils/token";
import { toast } from "react-toastify";
import axios from "axios";
export default function ReadyForDispatch() {
  const [loading, setLoading] = useState(false);
  const [readyfordispatch, setReadyfordispatch] = useState([]);
  const fetchReadyfordispatch = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication token missing!");
      return;
    }
    try {
      setLoading(true);
      const response = await axios.get(
        `${config.API}/inspection/readyfordispatch`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const result = response.data;
      if (result.success) {
        setReadyfordispatch(result?.unit_completed || []);
        console.log("fetchReadyfordispatch Data:", result?.unit_completed);
      } else {
        toast.warning(result.message || "No data found!");
        console.warn("API returned success: false", result);
      }
    } catch (err) {
      console.error("Error fetching fetchReadyfordispatch:", err.message);
      toast.error("Something went wrong while fetching data!");
    } finally {
      setLoading(false);
    }
  };
  const submitReadyfordispatch = async (id) => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication token missing!");
      return;
    }
    try {
      const response = await axios.post(
        `${config.API}/inspection/readyfordispatchfile`,
        { id }, 
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const result = response.data;
      if (result.success) {
        toast.success(result.message || "data submitted successfully!");
        console.log("submitReadyfordispatch Data:", result);
      } else {
        toast.warning(result.message || "Request failed. Please try again.");
        console.warn("API returned success: false", result);
      }
    } catch (err) {
      console.error("Error fetching fetchReadyfordispatch:", err.message);
      toast.error("Something went wrong while submitting data!");
    }
  };
  useEffect(() => {
    fetchReadyfordispatch();
  }, []);
  return (
    <div className="container-fluid my-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="mb-3">Ready For Dispatch</h5>
          <Table responsive className="align-middle">
            <thead>
              <tr className="text-muted">
                <th className="text-nowrap">Product ID</th>
                <th className="text-nowrap">PO Number</th>
                <th className="text-nowrap">Product Name</th>
                <th className="text-nowrap">Quantity</th>
                <th className="text-nowrap">Approval Date</th>
                <th>Action</th>
              </tr>
            </thead>
            {loading ? (
              <tbody>
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    <Loader />
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {readyfordispatch?.length > 0 ? (
                  readyfordispatch.map((dispatch, idx) => (
                    <tr key={idx}>
                      <td>{dispatch?.product?.product_code}</td>
                      <td className="text-nowrap">
                        {dispatch?.purchase_order?.po_number || "-"}
                      </td>
                      <td className="text-nowrap">{dispatch?.product?.name}</td>
                      <td className="text-nowrap">{dispatch?.actual_quantity}</td>
                      <td className="text-nowrap">
                        {dispatch?.purchase_order?.delivery_date || "-"}
                      </td>
                      <td>
                        <Button
                          variant="warning"
                          size="sm"
                          className="text-light text-nowrap"
                          onClick={() =>
                            submitReadyfordispatch(dispatch?.id)
                          } 
                        >
                          <BiMessageSquareDetail /> Ready for Dispatch
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center text-muted py-4">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </Table>
        </div>
      </div>
    </div>
  );
}
